import moment from 'moment';

/**
 * Format a date to DD/MM/YYYY format using moment.js
 * @param date The date to format
 * @returns Formatted date string in DD/MM/YYYY format
 */
export function formatDate(date: number, locale: string, format?: string): string {
  moment.locale(locale || 'fr');
  return moment(date).format(format || 'DD MMM YYYY, HH:mm');
}

/**
 * Format a date to YYYYMMDD format (without separators) for URL usage
 * @param date The date to format
 * @returns Formatted date string in YYYYMMDD format
 */
export function formatDateForUrl(date: Date): string {
  return moment(date).format('DDMMYYYY');
}

export function formatDateForInput(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function formatDateTime(date: string, dateFormat = ''): string {
  if (!date) return '';

  const OUTPUT = 'DD/MM/YYYY HH:mm';

  // No format → try as timestamp
  if (!dateFormat) {
    const timestamp = Number(date);
    if (!Number.isNaN(timestamp)) {
      const m = moment(timestamp);
      return m.isValid() ? m.format(OUTPUT) : '';
    }
    return '';
  }

  // Format provided → parse with that format
  const m = moment(date, dateFormat);
  return m.isValid() ? m.format(OUTPUT) : '';
}
